import { useCallback, useEffect, useState } from 'react';

import { Job } from '~extension/web2print/model/Job';
import { SapExportModal } from '~extension/web2print/view/SapExport/SapExportModal';
import useDelayFn from '~hooks/useDelayFn';

export function SapExportModalController({ job, onClose }: { job: Job; onClose: () => void }) {
  const delayedOnClose = useDelayFn(onClose, 500);
  const [isOpen, setIsOpen] = useState<boolean>(false);

  // open download modal if required parameters are given
  useEffect(() => {
    setIsOpen(Boolean(job));
  }, [job]);

  // Handler: close dialog, but delay the closing to have smoother transitions
  const handleOnClose = useCallback(() => {
    setIsOpen(false);
    delayedOnClose();
  }, [delayedOnClose]);

  return <SapExportModal job={job} isOpen={isOpen} onClose={handleOnClose} />;
}
